import type { MetaPayload } from '../../shared/types';

interface FiltersProps {
  meta: MetaPayload | null;
  selectedCategory: string | null;
  selectedTag: string | null;
  onCategoryChange: (id: string | null) => void;
  onTagChange: (id: string | null) => void;
}

export function Filters({
  meta,
  selectedCategory,
  selectedTag,
  onCategoryChange,
  onTagChange,
}: FiltersProps) {
  if (!meta) return null;
  const { categories, tags } = meta;
  if (categories.length === 0 && tags.length === 0) return null;

  return (
    <div className="space-y-4">
      {categories.length > 0 && (
        <div>
          <div className="mb-2 text-xs font-semibold uppercase tracking-wider text-ink-500">
            Categories
          </div>
          <div className="flex flex-wrap gap-2">
            <button
              type="button"
              onClick={() => onCategoryChange(null)}
              className={selectedCategory == null ? 'pill-active' : 'pill'}
            >
              All
            </button>
            {categories.map((c) => (
              <button
                type="button"
                key={c.id}
                onClick={() => onCategoryChange(selectedCategory === c.id ? null : c.id)}
                className={selectedCategory === c.id ? 'pill-active' : 'pill'}
              >
                {c.name}
                <span className="opacity-60">{c.count}</span>
              </button>
            ))}
          </div>
        </div>
      )}

      {tags.length > 0 && (
        <div>
          <div className="mb-2 text-xs font-semibold uppercase tracking-wider text-ink-500">
            Tags
          </div>
          <div className="flex flex-wrap gap-2">
            {tags.map((t) => (
              <button
                type="button"
                key={t.id}
                onClick={() => onTagChange(selectedTag === t.id ? null : t.id)}
                className={selectedTag === t.id ? 'pill-active' : 'pill'}
              >
                #{t.name}
                <span className="opacity-60">{t.count}</span>
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
